module.exports = __webpack_public_path__ + "static/img/89020E_2_3_R_20191227_LC.37f49b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89020E_2_3_R_20191227_LC.png
// module id = g4ol
// module chunks = 0